// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RZafU","top":"styles_top__RU9lr"};